import { render } from "./TrailMakingA.vue?vue&type=template&id=6496f8a0&scoped=true"
import script from "./TrailMakingA.vue?vue&type=script&lang=js"
export * from "./TrailMakingA.vue?vue&type=script&lang=js"

import "./TrailMakingA.vue?vue&type=style&index=0&id=6496f8a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6496f8a0"]])

export default __exports__